import { createContext } from 'react';

export const BookValuesContext = createContext({
  getLunrSearchIndex: async () => {},
});

export default BookValuesContext;
